/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CurrencySymbol } from '../models/CurrencySymbol';
import type { EndDate } from '../models/EndDate';
import type { EventId } from '../models/EventId';
import type { EventNote } from '../models/EventNote';
import type { FuelCurrency } from '../models/FuelCurrency';
import type { FuelCurrencyDefault } from '../models/FuelCurrencyDefault';
import type { FuelLossTolerance } from '../models/FuelLossTolerance';
import type { FuelPrice } from '../models/FuelPrice';
import type { FuelReceipt } from '../models/FuelReceipt';
import type { FuelReceiptBase } from '../models/FuelReceiptBase';
import type { FuelReceiptFuelType } from '../models/FuelReceiptFuelType';
import type { FuelReceiptId } from '../models/FuelReceiptId';
import type { RefuelingTolerance } from '../models/RefuelingTolerance';
import type { StartDate } from '../models/StartDate';
import type { VehicleId } from '../models/VehicleId';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class RefuelingService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Export fuel receipts
     * Export fuel receipts
     * @param vehicleId
     * @param startDate
     * @param type
     * @param endDate
     * @returns binary OK
     * @throws ApiError
     */
    public exportFuelReceipts(
        vehicleId: Array<VehicleId>,
        startDate: StartDate,
        type: 'xlsx' | 'csv' | 'autoplan' | 'pdf',
        endDate?: EndDate,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/refueling/export',
            query: {
                'vehicle_id': vehicleId,
                'start_date': startDate,
                'end_date': endDate,
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                413: `Export data too large`,
                500: `Server error`,
                504: `Server error`,
            },
        });
    }
    /**
     * Edit fuel receipt
     * Edit fuel receipt
     * @param receiptId Fuel receipt ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public editFuelReceipt(
        receiptId: string,
        requestBody: FuelReceipt,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/refueling/receipt/{receipt_id}',
            path: {
                'receipt_id': receiptId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete fuel receipt
     * Delete fuel receipt
     * @param receiptId Fuel receipt ID
     * @returns void
     * @throws ApiError
     */
    public deleteFuelReceipt(
        receiptId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/refueling/receipt/{receipt_id}',
            path: {
                'receipt_id': receiptId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign fuel receipt
     * Assign fuel receipt to a refueling event
     * @param eventId Event ID
     * @param requestBody
     * @returns any Receipt saved
     * @throws ApiError
     */
    public assignFuelReceipt(
        eventId: string,
        requestBody: (FuelReceiptBase & FuelCurrencyDefault & FuelReceiptFuelType & EventNote & {
            amount: number;
            /**
             * Fuel receipt date
             */
            date: string;
        }),
    ): Observable<{
        id: FuelReceiptId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/refueling/assign/{event_id}',
            path: {
                'event_id': eventId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Refueling
     * Get refueling & fuel loss events with receipts
     * @param vehicleId
     * @param startDate
     * @param fuelLossTolerance
     * @param refuelingTolerance
     * @param endDate
     * @returns any OK
     * @throws ApiError
     */
    public listRefueling(
        vehicleId: VehicleId,
        startDate: StartDate,
        fuelLossTolerance: FuelLossTolerance,
        refuelingTolerance: RefuelingTolerance,
        endDate?: EndDate,
    ): Observable<Array<({
        end_at: string | null;
        id: EventId | null;
        location: {
            city?: string | null;
            country_code?: string | null;
            street_name?: string | null;
            street_number?: string | null;
            zip_code?: string | null;
        } | null;
        receipt: (FuelReceiptId & FuelReceiptBase & FuelCurrency & FuelReceiptFuelType & EventNote & {
            currency_symbol?: CurrencySymbol;
        } & {
            amount: number;
            /**
             * Fuel receipt date
             */
            date: string;
            price: FuelPrice;
            /**
             * Currency code (ISO 4217)
             */
            currency: string | null;
            fuel_type: 'petrol' | 'diesel' | 'hvo' | 'e85' | 'lpg' | 'cng' | 'electricity' | 'hydrogen' | 'adblue' | null;
            /**
             * Note
             */
            note: string | null;
            currency_symbol: CurrencySymbol;
        }) | null;
        start_at: string | null;
        type: 'refueling' | 'fuel_loss' | 'refueling_can' | 'fuel_loss_can';
        value: number | null;
        vehicle_id: VehicleId;
    } & EventNote)>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/refueling/{vehicle_id}/',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'fuel_loss_tolerance': fuelLossTolerance,
                'refueling_tolerance': refuelingTolerance,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Add fuel receipt
     * Add fuel receipt when refueling event not detected
     * @param vehicleId
     * @param requestBody
     * @returns any Receipt saved
     * @throws ApiError
     */
    public addFuelReceipt(
        vehicleId: VehicleId,
        requestBody: (FuelReceiptBase & FuelCurrencyDefault & FuelReceiptFuelType & EventNote & {
            amount: number;
            /**
             * Fuel receipt date
             */
            date: string;
        }),
    ): Observable<{
        id: FuelReceiptId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/refueling/{vehicle_id}/',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
}
